import React, { useState } from "react";
import cx from "classnames";
import { useSelector } from "react-redux";

import CartLineItem from "./CartLineItem";
import DashedSeparator from "shared/components/DashedSeparator";
import DiscountCodeField from "./DiscountCodeField";
import PriceChangingLineItems from "./PriceChangingLineItems";
import SummaryLineItem from "./SummaryLineItem";
import RecurringCost from "./RecurringCost";
import PromoCodeOptions from "./PromoCodeOptions";

import styles from "./SubscriptionSummary.module.scss";

import { getStore } from "../../../shared/utility";
import { getFreeDisplayLineItems } from "./freeDisplayLineItems";
import { FREE_MATCHA_TIN_SKU } from "../tinLineItems";

const SubscriptionSummary = ({ className }) => {
  const { cart } = useSelector((s) => s.checkout);

  const subscriptionProducts = cart.products.filter(
    (product) => product.type === "subscription",
  );

  // This will fetch the child product representing the starter pack.
  // const starterPackProduct = cart.products.find(
  //   (product) => product.children?.[0]?.type === "rule"
  // )?.children[0];

  const [promoCode, setPromoCode] = useState(null);

  const handlePromoClick = (code) => {
    setPromoCode(code);
  };

  const freeDisplayLineItems = getFreeDisplayLineItems(cart);

  return (
    <div
      className={cx(
        "gkit-d-flex gkit-flex-column subscriptionSummaryContainer",
        styles.container,
        className,
      )}
    >
      {/* List Line Items */}
      {cart.products.map((lineItem, idx) => {
        // Shown as a free tin by getFreeDisplayLineItems instead.
        if (
          lineItem.type === "onetime" &&
          lineItem.variant.sku === FREE_MATCHA_TIN_SKU
        )
          return null;

        return (
          <CartLineItem
            className={cx(idx > 0 && "gkit-mt-4")}
            key={String(lineItem.id)}
            lineItem={lineItem}
          />
        );
      })}
      {/* Freebies the cart doesn't return as line items of its own. */}
      {freeDisplayLineItems.map((lineItem) => (
        <CartLineItem
          className="gkit-mt-4"
          key={lineItem.id}
          lineItem={lineItem}
        />
      ))}
      {getStore(window.location.search) === "UK" ||
      getStore(window.location.search) === "EU" ? (
        <PromoCodeOptions
          className="gkit-my-3"
          onButtonClick={handlePromoClick}
          selectedCode={promoCode}
        />
      ) : null}

      <DashedSeparator className="gkit-my-2" />
      {/* Discount Code */}
      <DiscountCodeField
        promoCode={promoCode}
        onDiscountRemoved={() => setPromoCode(null)}
      />
      {/* Cost Breakdown */}
      <PriceChangingLineItems />
      <DashedSeparator className="gkit-my-2" />
      {/*
        This may have an issue for anonymous carts with paid shipping methods..
      */}
      <SummaryLineItem
        className="gkit-mt-2"
        isLarge={true}
        label="Total"
        value={cart.payment_due.formatted}
      />
      {subscriptionProducts.length ? (
        <>
          <DashedSeparator className="gkit-my-2" />

          <RecurringCost
            className="gkit-mt-2"
            label="Recurring subtotal"
            cart={cart}
            interval={cart.subscription.interval}
            terms="Excludes gift subscriptions and any discounts - skip, pause, or cancel anytime."
          />
        </>
      ) : null}
    </div>
  );
};

export default SubscriptionSummary;
